import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-8 md:py-12 bg-white" data-id="element-92" data-mp="1o3x39onecu32">
      <div className="max-w-[720px] mx-auto px-4 sm:px-6 lg:px-8" data-id="element-93" data-mp="1o33s8bhenif4">
        <div className="flex flex-col sm:flex-row items-center gap-4 sm:gap-5 bg-clinical-mist border border-clinical-line/70 rounded-2xl p-5 md:p-6 text-center sm:text-left" data-id="element-94" data-mp="223og3m26g4fh">
          <span className="flex-shrink-0 w-12 h-12 rounded-full bg-white border border-clinical-line flex items-center justify-center" data-id="element-95" data-mp="19ehgejqzl8sn">
            <ShieldCheck className="w-6 h-6 text-clinical-mid" strokeWidth={2.2} data-id="element-96" data-mp="14gz4qlll4fgy" />
          </span>
          <div data-id="element-97" data-mp="1j6dg1z8q16yz">
            <h2 className="text-lg md:text-xl font-black text-clinical-deep mb-1 uppercase tracking-wide" data-id="element-98" data-mp="1edtzquinfxqh">
              Compromiso de seguridad · 7 días
            </h2>
            <p className="text-[14px] md:text-[15px] text-clinical-ink leading-snug" data-id="element-99" data-mp="qm6ht23d7x0c">
              Tienes 7 días para usar el material en tu práctica. Si no te hace
              sentir más seguro frente al paciente, te devolvemos el{' '}
              <span className="font-bold text-clinical-deep" data-id="element-100" data-mp="ty2y8mmbuqik">100%</span> de tu
              compra. Sin complicaciones.
            </p>
          </div>
        </div>
      </div>
    </section>;
}